import { Middleware } from '@nuxt/types'
import Cookies from 'js-cookie'
import { isAuthenticated, removeAuthParameters } from '@/modules/zidAuth/localStorage'

const ignorePaths = ['/login', '/contractors', '/plans', '/logout']

const middleware: Middleware = context => {
  // 認証済みの場合は何もしない
  if (isAuthenticated()) {
    return
  }

  // 認証済みでなくても、ignorePathsに含まれるパスの場合は何もしない
  if (ignorePaths.includes(context.route.path)) {
    return
  }

  //
  // 認証できていない場合、各種初期化してログイン画面へ
  //

  removeAuthParameters()

  // cookieに格納されている会員番号を削除する
  // eslint-disable-next-line no-undef
  Cookies.remove('m_token', {
    path: process.env.COOKIE_PATH,
    domain: process.env.COOKIE_DOMAIN,
  })

  if (context.from.hash) {
    context.redirect(302, '/login')
  } else {
    // login画面から故意に中へアクセスしようとしてリダイレクトされた際、
    // routeのwatchが反応せずローディングが消えない事象への対応のため、
    // 末尾に#を付与している。
    context.redirect(302, '/login#')
  }
}

export default middleware
